<template>
  <figure
    class="relative overflow-hidden"
    :class="[
      hasBorder && 'rounded-2xl border border-solid border-gray-200',
      hasShadow && 'shadow-normal shadow-gray-400',
    ]"
  >
    <img
      :src="src"
      :alt="alt"
      loading="lazy"
      class="pointer-events-none absolute left-0 top-0 block h-full w-full object-contain"
    />
  </figure>
</template>

<script setup lang="ts">
  interface IProps {
    src: string;
    alt?: string;
    hasBorder?: boolean;
    hasShadow?: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    alt: '',
    hasBorder: true,
    hasShadow: true,
  });
</script>
